//SmartDrillTranslation
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import './SmartDrill.css';
import './FourLines.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import NumbersByLanguage from './NumbersByLanguage';
import CountingNumbers from '../../assets/pageimages/CountingNumbers.webp';

function SmartDrillTranslation() {
  const authState = useSelector(state => state.authReducer);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('English'); // Default language1
  const [selectedLanguage2, setSelectedLanguage2] = useState('None'); // Default language2
  const [selectedMedium, setSelectedMedium] = useState('MADSmania Sheets'); // Default medium
  const [selectedPracticeWith, setSelectedPracticeWith] = useState('Solo'); // Default practiced with
  const [selectedMethod, setSelectedMethod] = useState('View'); // Default method
  const [selectedGroup, setSelectedGroup] = useState('1-10'); // Default group
  const [practiceData, setPracticeData] = useState([]);
  const [showNumbers, setShowNumbers] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const languageList = [
    'Arabic', 'Assamese', 'Bangla', 'Burmese', 'Chinese', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Italian',
    'Javanese', 'Japanese', 'Kannada', 'Korean', 'Malayalam', 'Marathi', 'Odia', 'Polish', 'Portuguese',
    'Punjabi', 'Russian', 'Sinhala', 'Spanish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Urdu', 'Vietnamese'
  ];

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  const language2List = [
    'Arabic', 'Assamese', 'Bangla', 'Burmese', 'Chinese', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Italian',
    'Javanese', 'Japanese', 'Kannada', 'Korean', 'Malayalam', 'Marathi', 'Odia', 'Polish', 'Portuguese',
    'Punjabi', 'Russian', 'Sinhala', 'Spanish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Urdu', 'Vietnamese'
  ];

  const handleLanguage2Change = (language2) => {
    setSelectedLanguage2(language2);
  };

  const getNumberNamesForLanguage = (language, numbers) => {
    const numberNames = getNumberNames(language, numbers);
    return numberNames.map((name, index) => ({ numeral: numbers[index], name }));
  };


  const groupList = [
    "1-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90-100", "1-100", "1-50", "51-100"
  ];

  const handleGroupChange = (group) => {
    setSelectedGroup(group);
  };

  const methodList = [
    'View', 'Listen', 'By Heart'
  ];

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  const mediumList = [
    'MADSmania Sheets', 'Paper / Notebook', 'By Heart', 'Others'
  ];

  const handleMediumChange = (medium) => {
    setSelectedMedium(medium);
  };

  const practicewithList = [
    'Solo', 'Mother', 'Teacher', 'Father', 'Brother', 'Sister', 'Friend', 'Relatives', 'Others'
  ];

  const handlePracticeWithChange = (practicewith) => {
    setSelectedPracticeWith(practicewith);
  };

  const handleShowNumbers = () => {
    // Generate number names for both selected languages
    const numberNames1 = getNumberNames(selectedLanguage, numbers);
    const numberNames2 = getNumberNames(selectedLanguage2, numbers);

    // Update state to show the number names
    setShowNumbers({ numberNames1, numberNames2 });
  };

  const handleSavePractice = () => {
    // clearInterval(interval);
    // Calculate the end time and elapsed time
    const endTime = Date.now();
    const elapsedTimeMs = endTime - startTime;
    const elapsedTimeSeconds = elapsedTimeMs / 1000;

    // Calculate ecoPoints based on selectedMedium
    let ecoPoints = 0;
    if (selectedMedium === 'MADSmania Sheets') {
      ecoPoints = 25;
    } else if (selectedMedium === 'Paper / Notebook' || selectedMedium === 'By Heart') {
      ecoPoints = 5;
    } else {
      ecoPoints = 0;
    }

    // Create the data object
    const practiceData = {
      userId: authState.user.id,
      userName: authState.user.name,
      practiceLanguage: selectedLanguage,
      practiceLanguage2: selectedLanguage2,
      methodName: selectedMethod,
      mediumName: selectedMedium,
      groupName: selectedGroup,
      practicedWith: selectedPracticeWith,
      startTime: new Date(startTime),
      endTime: new Date(endTime),
      elapsedTimeMs,
      ecoPoints: ecoPoints,
      page: 'SMARTDrill Counting Numbers',
      dateCreated: new Date()
    };
    setPracticeData(prevData => [...prevData, practiceData]);
    setSaveButtonDisabled(true);
  };

  const handlePracticeAgain = () => {
    setMultiplicationTable([]);
    setError('');
    setNumber('');
    setFromNumber('');
    setToNumber('');
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setShowTimer(false);
    setStartTime(null);
    setEndTime(null);
    setElapsedTimeMs(0);
    setSaveButtonDisabled(false);
    setPracticeData(prevData => {
      if (!prevData) return [];
      return [...prevData, prevData];
    });
  };

  const handlePracticeOver = () => {
    // console.log('Practice Over');
  };

  // Function to generate numbers based on the selected group
  const generateNumbers = () => {
    const [start, end] = selectedGroup.split('-').map(Number);
    const numbers = [];
    for (let i = start; i <= end; i++) {
      numbers.push(i);
    }
    return numbers;
  };


  const getNumberNames = (language, numbers) => {
    const numberNames = {
      Arabic: ['واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة', 'عشرة'],
      Assamese: ['এক', 'দুই', 'তিনি', 'চার', 'পাঁচ', 'ছয়', 'সাত', 'আট', 'নয়', 'দশ'],
      Bangla: ['এক', 'দুই', 'তিন', 'চার', 'পাঁচ', 'ছয়', 'সাত', 'আট', 'নয়', 'দশ'],
      Burmese: ['တစ်', 'နှစ်', 'သုံး', 'လေး', 'ငါး', 'ခြောက်', 'ခုနှစ်', 'ရှစ်', 'ကိုး', 'တစ်ဆယ်'],
      Chinese: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      English: ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'],
      French: ['Un', 'Deux', 'Trois', 'Quatre', 'Cinq', 'Six', 'Sept', 'Huit', 'Neuf', 'Dix'],
      German: ['Eins', 'Zwei', 'Drei', 'Vier', 'Fünf', 'Sechs', 'Sieben', 'Acht', 'Neun', 'Zehn'],
      Gujarati: ['એક', 'બે', 'ત્રણ', 'ચાર', 'પાંચ', 'છ', 'સાત', 'આઠ', 'નવ', 'દસ'],
      Hindi: ['एक', 'दो', 'तीन', 'चार', 'पांच', 'छह', 'सात', 'आठ', 'नौ', 'दस'],
      Italian: ['Uno', 'Due', 'Tre', 'Quattro', 'Cinque', 'Sei', 'Sette', 'Otto', 'Nove', 'Dieci'],
      Javanese: ['Siji', 'Loro', 'Telu', 'Papat', 'Lima', 'Enem', 'Pitu', 'Wolu', 'Sanga', 'Sepuluh'],
      Japanese: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      Kannada: ['ಒಂದು', 'ಎರಡು', 'ಮೂರು', 'ನಾಲ್ಕು', 'ಐದು', 'ಆರು', 'ಏಳು', 'ಎಂಟು', 'ಒಂಬತ್ತು', 'ಹತ್ತು'],
      Korean: ['하나', '둘', '셋', '넷', '다섯', '여섯', '일곱', '여덟', '아홉', '열'],
      Malayalam: ['ഒന്ന്', 'രണ്ട്', 'മൂന്ന്', 'നാല്', 'അഞ്ച്', 'ആറ്', 'ഏഴ്', 'എട്ട്', 'ഒന്നും', 'പത്ത്'],
      Marathi: ['एक', 'दोन', 'तीन', 'चार', 'पाच', 'सहा', 'सात', 'आठ', 'नऊ', 'दहा'],
      Odia: ['ଏକ', 'ଦୁଇ', 'ତ୍ରି', 'ଚାରୁ', 'ପାଞ୍ଚ', 'ଛଅ', 'ସାତ', 'ଆଠ', 'ନବ', 'ଦଶ'],
      Polish: ['Jeden', 'Dwa', 'Trzy', 'Cztery', 'Pięć', 'Sześć', 'Siedem', 'Osiem', 'Dziewięć', 'Dziesięć'],
      Portuguese: ['Um', 'Dois', 'Três', 'Quatro', 'Cinco', 'Seis', 'Sete', 'Oito', 'Nove', 'Dez'],
      Punjabi: ['ਇੱਕ', 'ਦੋ', 'ਤਿੰਨ', 'ਚਾਰ', 'ਪੰਜ', 'ਛੇ', 'ਸੱਤ', 'ਅੱਠ', 'ਨੌ', 'ਦਸ'],
      Russian: ['Один', 'Два', 'Три', 'Четыре', 'Пять', 'Шесть', 'Семь', 'Восемь', 'Девять', 'Десять'],
      Sinhala: ['එක', 'දෙක', 'තුන', 'හතර', 'පහ', 'හය', 'හත', 'අට', 'නවය', 'දහය'],
      Spanish: ['Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve', 'Diez'],
      Tamil: ['ஒன்று', 'இரண்டு', 'மூன்று', 'நான்கு', 'ஐந்து', 'ஆறு', 'ஏழு', 'எட்டு', 'ஒன்பது', 'பத்து'],
      Telugu: ['ఒకటి', 'రెండు', 'మూడు', 'నాలుగు', 'ఐదు', 'ఆరు', 'ఏడు', 'ఎనిమిది', 'తొమ్మిది', 'పది'],
      Thai: ['หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า', 'สิบ'],
      Turkish: ['Bir', 'İki', 'Üç', 'Dört', 'Beş', 'Altı', 'Yedi', 'Sekiz', 'Dokuz', 'On'],
      Urdu: ['ایک', 'دو', 'تین', 'چار', 'پانچ', 'چھ', 'سات', 'آٹھ', 'نو', 'دس'],
      Vietnamese: ['Một', 'Hai', 'Ba', 'Bốn', 'Năm', 'Sáu', 'Bảy', 'Tám', 'Chín', 'Mười']

    }
    for (const lang in numberNames) {
      if (numberNames.hasOwnProperty(lang)) {
        numberNames[lang] = generateNumberNames(lang, numbers);
      }
    }
  
    return numberNames[language];
  };

  const numbers = generateNumbers();
  // const numberNames = getNumberNames(selectedLanguage, numbers);
  const numberNamesLanguage1 = getNumberNamesForLanguage(selectedLanguage, numbers);
  const numberNamesLanguage2 = getNumberNamesForLanguage(selectedLanguage2, numbers);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mb-2 mx-2 border-b border-b-gray-300 text-white'>SMARTDrill - Numbers Name</h2>
      </div>
      <div className="mx-auto max-w-[760px]">
        <div className="flex justify-center mt-1 mb-1 ml-4 mr-4 relative">
          <img className="align-middle" src={CountingNumbers} alt="KidMotherImage" />
          <div className="timer-and-speaker absolute top-0 right-0 flex items-center">
            <span className="timer">{formatTime(elapsedTime)}</span>
            <FontAwesomeIcon icon={faVolumeUp} className="ml-2" />
          </div>
        </div>
        <div className="flex justify-center mb-1">
          <div className='ml-4'>
            <p className=' text-white'>1st Language</p>
            <select value={selectedLanguage} onChange={(e) => handleLanguageChange(e.target.value)} className="p-2">
              {languageList.map((language, index) => (
                <option key={index} value={language}>{language}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className=' text-white'>2nd Language</p>
            <select value={selectedLanguage2} onChange={(e) => handleLanguage2Change(e.target.value)} className="p-2">
              {language2List.map((language2, index) => (
                <option key={index} value={language2}>{language2}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center mb-2">
          <div className='ml-4'>
            <p className=' text-white'>Group</p>
            <select value={selectedGroup} onChange={(e) => handleGroupChange(e.target.value)} className="ml-2 p-2">
              {groupList.map((group, index) => (
                <option key={index} value={group}>{group}</option>
              ))}
            </select>
          </div>

          <div className='ml-4'>
            <p className=' text-white'>Practice Method</p>
            <select value={selectedMethod} onChange={(e) => handleMethodChange(e.target.value)} className="p-2 ml-2">
              {methodList.map((method, index) => (
                <option key={index} value={method}>{method}</option>
              ))}
            </select>
          </div>

        </div>
        <div className="flex justify-center mb-2">
          <div className='ml-4'>
            <p className='text-white'>Practice Medium</p>
            <select value={selectedMedium} onChange={(e) => handleMediumChange(e.target.value)} className="p-2 ml-2">
              {mediumList.map((medium, index) => (
                <option key={index} value={medium}>{medium}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className='text-white'>Practicing With</p>
            <select value={selectedPracticeWith} onChange={(e) => handlePracticeWithChange(e.target.value)} className="p-2 ml-2">
              {practicewithList.map((practicewith, index) => (
                <option key={index} value={practicewith}>{practicewith}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="mx-auto justify-center items-center max-w-[760px]">
          <button onClick={handleShowNumbers} className="ml-2 p-2 bg-blue-500 text-white">Show Number Names</button>
          {showNumbers && (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Numerals</th>
                    <th>{selectedLanguage}</th>
                    <th>{selectedLanguage2}</th>
                  </tr>
                </thead>
                <tbody>
                  {numbers.map((number, index) => (
                    <tr key={index}>
                      <td>{number}</td>
                      <td>{showNumbers.numberNames1[index]}</td>
                      <td>{showNumbers.numberNames2[index]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
}

export default SmartDrillTranslation;
